import './shims/style-order'; // must be first: patches <head> so runtime-injected <style> lands before app CSS
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React, { lazy } from 'react';
import { createRoot } from 'react-dom/client';
import { SWRConfig } from 'swr';
import { CoralogixRum } from '@coralogix/browser';
import './index.css';
import App from './app/App.jsx';
import 'primereact/resources/themes/lara-light-indigo/theme.css'; //theme
import 'primereact/resources/primereact.min.css'; //core css
import 'primeicons/primeicons.css'; //icons
import 'primeflex/primeflex.css';
import './i18n';
import './assets/nextgen-global.min.css';
import { ThemeProvider, getCurrentTheme } from '@lsq/nextgen/v2/stylesmanager';
import { useNotificationStore } from '@lsq/nextgen/notification';
import withSuspense from '@lsq/nextgen/suspense';

const Notification = withSuspense(lazy(() => import('@lsq/nextgen/notification')));

const NotificationWrapper = () => {
  const { notification } = useNotificationStore();
  return notification ? <Notification theme={getCurrentTheme()} /> : null;
};

const getRumEnvironment = () => {
  const host = window.location.host;
  if (host.endsWith('marketxpander.net')) return 'dev';
  if (host.endsWith('crm4b2c.com')) return 'test';
  if (host.endsWith('lsq-staging.com')) return 'staging';
  if (host.endsWith('leadsquared.com')) return 'production';
  return 'local';
};

CoralogixRum.init({
  application: 'dashboard',
  environment: getRumEnvironment(),
  public_key:
    getRumEnvironment() === 'production'
      ? process.env.REACT_APP_CORALOGIX_RUM_PROD_PUBLIC_KEY
      : process.env.REACT_APP_CORALOGIX_RUM_PUBLIC_KEY || '',
  coralogixDomain: 'AP1',
  version: '1.0.0',
  sessionRecordingConfig: { enable: false },
  instrumentations: {
    errors: true,
    fetch: true,
    xhr: true,
    web_vitals: true,
    interactions: true,
    resources: false,
    long_tasks: false,
    custom: true
  }
});

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <ThemeProvider>
    <React.StrictMode>
      {/* Global SWR default: don't revalidate on window focus. This is a builder
          surface — a focus refetch can overwrite in-progress edits. Hooks may still
          opt back in individually where a fresh fetch is desired. */}
      <SWRConfig value={{ revalidateOnFocus: false }}>
        <App />
        <NotificationWrapper />
      </SWRConfig>
    </React.StrictMode>
  </ThemeProvider>
);
